// extracted by mini-css-extract-plugin
export default {"web_login":"style_web_login__SAX5b","login_form":"style_login_form__MB78H"};